var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/social/google-plus.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg viewBox=\"0 0 179.5 114\" class=\"c-social__google-plus\" aria-labelledby=\"google-plus-svg-title\" xmlns=\"http://www.w3.org/2000/svg\">\n\t<title id=\"google-plus-svg-title\">\n        ";
output += runtime.suppressValue((lineno = 2, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["social-googleplus"])), env.opts.autoescape);
output += "\n    </title>\n\t<path d=\"M159.7 46.8V27.1h-14.1v19.8h-20.3V61h20.3v20.3h14.1V61h19.8V46.8h-19.8zM57 45.7v22.6h30.8C83 82.9 75.5 90.9 57 90.9c-18.7 0-33.3-15.2-33.3-33.9S38.3 23.1 57 23.1c9.9 0 16.3 3.5 22.1 8.3 4.7-4.7 4.3-5.4 16.2-16.6C85.2 5.6 71.8 0 57 0 25.5 0 0 25.5 0 57s25.5 57 57 57c47.1 0 58.6-41 54.7-68.3H57z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/social/google-plus.j2"] , dependencies)